import React from "react";
import { Button, createStyles, IconButton, makeStyles, Theme } from "@material-ui/core";
import isHtml from 'is-html';
import { ArrowTooltip } from ".";
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    olButtonParent: {
      background: "var(--ol-subtle-background-color)",
      position: 'absolute',

      zIndex: 10,
      borderRadius: "4px"
    },
    olButtonTopLeft: {
      top: "0.5em",
      left: "0.5em",
    },
    olButtonBottomLeft: {
      bottom: "0.5em",
      left: "0.5em",
    },
    olButton: {
      padding: "0px",
      margin: "1px",
      borderRadius: "2px",
      backgroundColor: "var(--ol-background-color) !important",
      color: "var(--ol-subtle-foreground-color)",
      minWidth: "22px",
      "&:hover": {
        outline: "1px solid var(--ol-subtle-foreground-color)",
        color: "var(--ol-foreground-color)"
      },
      "& svg": {
        width: "22px",
        height: "22px"
      }
    },
    olButtonRotate: {
      "-webkit-transition": "-webkit-transform .3s ease-in-out",
      transition: "transform .3s ease-in-out",
      "&:hover": {
        "-webkit-transform": "rotate(-180deg)",
        transform: "rotate(-180deg)"
      }
    }
  }),
);

export interface EnhancedIconButtonProps {
  title: string
  visible?: boolean
  onClick?(event?): void,
  disabled?: boolean
  children?: any
}

export const EnhancedIconButton = (props: EnhancedIconButtonProps) => {
  const {title, visible=true, onClick, disabled=false, children} = props;

  let tooltipText = disabled
    ? `${title} (Disabled)`
    : title;

  let tooltipTitle = isHtml(tooltipText)
    ? (<div dangerouslySetInnerHTML={{__html: tooltipText}}/>)
    : tooltipText;

  return (
    <React.Fragment>
      {visible && (<ArrowTooltip title={tooltipTitle}>
        <IconButton
          size="small"
          onClick={(event) => {
            if (disabled) return;
            if (!onClick) return;
            onClick(event);
          }}
          style={{
            ...(disabled && {opacity: 0.3}),
          }}
        >
          {children}
        </IconButton>
      </ArrowTooltip>)}
    </React.Fragment>
  );
};

interface OpenLayersIconProps {
  rotate?: boolean;
  onClick(event): void;
  placement: "top-left" | "bottom-left";
  children: React.ReactNode;
}

export const OpenLayersIcon = (props: OpenLayersIconProps) => {
  const {rotate=false, placement, onClick} = props;
  const classes = useStyles();

  return (
    <div className={clsx(classes.olButtonParent, {
      [classes.olButtonRotate]: rotate,
      [classes.olButtonTopLeft]: placement === "top-left",
      [classes.olButtonBottomLeft]: placement === "bottom-left"
    })}>
      <Button
        className={classes.olButton}
        onClick={onClick}
      >
        {props.children}
      </Button>
    </div>
  );
};
